import fetch from "../fetch";

export default ({ fundId }) =>
  fetch({
    path: `/hy/funds/${fundId}/placement-agents`,
  });
